function Footer() {
  return (
    <div className="footer">&lt; Made by Jessica Strawford &copy; 2021 /&gt;</div>
  )
}

export default Footer